import React from 'react';
import { observer } from 'mobx-react';
import { ThemeStore } from '@gamiphy/loyalty-station-desktop/store/theme';
import { FramePortal } from '@gamiphy/loyalty-station-desktop/components';
import { CoreStore } from '@gamiphy/loyalty-station-desktop/store/core';
import { useMuiTheme } from '@gamiphy/loyalty-station-desktop/theme';
import { Box, ClickAwayListener } from '@mui/material';
import { AppWelcomeGiftStore } from '@gamiphy/loyalty-station-desktop/store/appWelcomeGift';
import { UiStore } from '@gamiphy/loyalty-station-desktop/store/ui';
import { useResizeDetector } from 'react-resize-detector';
import WelcomeGiftNotification from './WelcomeGiftNotification';

const WelcomeGiftNotificationFrame: React.FC = observer(() => {
  const theme = useMuiTheme();
  const [frameHeight, setFrameHeight] = React.useState<number>();

  const {
    height,
    ref,
  } = useResizeDetector();

  React.useEffect(() => {
    if (height) {
      setFrameHeight(height);
    }
  }, [height]);

  return !CoreStore.initialized ? null : (
    <ClickAwayListener onClickAway={() => UiStore.closeWelcomeGiftNotification()}>
      <FramePortal
        stylesheets={[...ThemeStore.fontStyleSheets]}
        theme={theme}
        sx={{ height: frameHeight }}
      >
        <Box ref={ref}>
          {AppWelcomeGiftStore.welcomeGift && (
            <WelcomeGiftNotification welcomeGift={AppWelcomeGiftStore.welcomeGift} />
          )}
        </Box>
      </FramePortal>
    </ClickAwayListener>
  );
});

export default WelcomeGiftNotificationFrame;
